module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAVCAYAAAByrA+0AAABBElEQVQ4jY3SOTMDcRzH4UfotCRxVcaVjBmN3mJGo9d7Y2qvQOGITpPCMeIaCgYJeo1Csb+d2YlkY9v9PLv/2f0ONZvNMwxjGx8GXCWMYhUNlP8DtnCLWqDKIPCOBDc5VC0C0A7UwlKgiSIAnUDXWAw0WQRIv1KCKywEmioC8IkNXGI+0HQRyNAmLjCH0wz1A3l0jtlAM0UAvrCDn0B7g8AY9jGCJ+wWgTEcYgWPWMNzPzCOo4gfIn4Rr+oVH2MZ91jHa3azG5RxgjruIn7LB/kjVaQ/qS5db9Id50E14pp0tYl0xX+uknSVDelKWxG3e8UZOJCusxVn7vSLM/CNZjy5MIZfkWU8kv67YJEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/workorder/arrow.png
// module id = PH0M
// module chunks = 1